import { render, staticRenderFns } from "./LmCommentBuilderUi.vue?vue&type=template&id=4783ed6b&"
import script from "./LmCommentBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmCommentBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports